import { registerComponent } from "helpers";

registerComponent(
  "localization-form",
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.input = this.querySelector("[data-input]");
      this.values = this.querySelectorAll("[data-value]");

      this.values.forEach((element) =>
        element.addEventListener("click", this.submit.bind(this)),
      );
    }

    submit(event) {
      this.input.value = event.currentTarget.dataset.value;
      this.form.submit();
    }
  },
);
